import { render } from "./TransferEmployeeM.vue?vue&type=template&id=95e2fc3e&scoped=true"
import script from "./TransferEmployeeM.vue?vue&type=script&lang=js"
export * from "./TransferEmployeeM.vue?vue&type=script&lang=js"

import "./TransferEmployeeM.vue?vue&type=style&index=0&id=95e2fc3e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95e2fc3e"]])

export default __exports__